import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type {
  MatingDisplayBy,
  MatingPredictorResponse,
  MatingSearchFormValues,
} from '@/components/publicSearch/mating/types';
import { MATING_DISPLAY_BY } from '@/components/publicSearch/mating/types';
import { defaultFormValues } from '@/components/publicSearch/mating/MatingPredictorSearch';

const STORAGE_KEY = 'MatingPredictorStore';

export type MatingPredictorStoreState = {
  /** Society org id (string from public search context) when results were last saved */
  persistedOrgId: string | null;
  formValues: MatingSearchFormValues;
  displayBy: MatingDisplayBy;
  currentPageIndex: number;
  data: MatingPredictorResponse | null;
  tableScrollTop: number;

  setFormValues: (formValues: MatingSearchFormValues) => void;
  setDisplayBy: (displayBy: MatingDisplayBy) => void;
  setCurrentPageIndex: (currentPageIndex: number) => void;
  setData: (data: MatingPredictorResponse | null, orgId: string) => void;
  setTableScrollTop: (tableScrollTop: number) => void;
  clear: () => void;
};

const initialState = {
  persistedOrgId: null as string | null,
  formValues: defaultFormValues,
  displayBy: MATING_DISPLAY_BY.SIRE,
  currentPageIndex: 0,
  data: null as MatingPredictorResponse | null,
  tableScrollTop: 0,
};

export const useMatingPredictorStore = create<MatingPredictorStoreState>()(
  persist(
    (set) => ({
      ...initialState,

      setFormValues: (formValues) => set({ formValues }),

      setDisplayBy: (displayBy) => set({ displayBy }),

      setCurrentPageIndex: (currentPageIndex) => set({ currentPageIndex }),

      setData: (data, orgId) =>
        set((state) => ({
          data,
          persistedOrgId: orgId.trim() !== '' ? orgId : state.persistedOrgId,
          currentPageIndex: 0,
          tableScrollTop: 0,
        })),

      setTableScrollTop: (tableScrollTop) => set({ tableScrollTop }),

      clear: () =>
        set({
          ...initialState,
        }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        persistedOrgId: state.persistedOrgId,
        formValues: state.formValues,
        displayBy: state.displayBy,
        currentPageIndex: state.currentPageIndex,
        data: state.data,
        tableScrollTop: state.tableScrollTop,
      }),
    },
  ),
);
